import moment from 'moment';

class DisplaySuggestionsController {

    constructor(basket, checkout, suggestionsService, guestnameService, loadingService) {
        this.basket = basket;
        this.checkout = checkout;
        this.suggestionsService = suggestionsService;
        this.guestname = guestnameService;
        this.loadingService = loadingService;
    }

    $onInit () {
        if (this.basket.contents.has_suggestions) {
            return this.loadSuggestions()
                .then(() => {
                    if (!this.isAdmin) {
                        this.checkout.setStepByName('suggestions');
                    }
                });
        }
    }

    loadSuggestions () {
        this.loadingService.startLoading('suggestions');
        return this.requestSuggestions()
            .then(() => {
                this.loadingService.stopLoading('suggestions');
            });
    }

    getSuggestions () {
        this.loadingService.startLoading('suggestions');
        return this.basket.submit('delete_orders').then(() => {
            return this.requestSuggestions();
        })
            .then(() => {
                this.loadingService.stopLoading('suggestions');
            });
    }

    requestSuggestions () {
        return this.basket.promise.then(() => {
            return this.suggestionsService.getSuggestions().then(() => {
                this.setMultiGuestUpgrades();
                return;
            });
        });
    }

    findAvailableUpgrade (item, quantity = 1) {
        let type = item.item_summary.type_name;
        let date = moment(item.date).format('YYYY-MM-DD');

        if (item.item_summary.type_name === 'OptionGroupOption') {
            if (item.item.option_type === 'Custom') {
                return true;
            }

            type = 'Treatment';
        }

        if (item.canUpgradeTo) {
            return this.getUpgradeOrUnset(date, type, item, quantity);
        }
    }

    getUpgradeOrUnset (date, type, item, quantity) {
        let upgrade = this.suggestionsService.getAvailableUpgrade(date, type, item.canUpgradeTo, item.preferred_time, quantity);
        if (upgrade) {
            return upgrade;
        }

        item.canUpgradeTo = false;
        return false;
    }

    itemOrChildrenCanUpgrade (item) {
        if (this.canUpgradeSingleItem(item)) {
            return true;
        }

        if (item.item_children) {
            return !!item.item_children.find(child => child.canUpgradeTo || child.upgraded);
        }

        return false;
    }

    upgradeAvailable () {
        return !!this.basket.contents.guest_details.find(guest => {
            return this.guestCanUpgrade(guest);
        });
    }

    guestCanUpgrade (guest) {
        return !!guest.item_details.find(item => {
            return this.itemOrChildrenCanUpgrade(item);
        });
    }

    canShowUpgrades () {
        return !this.loadingService.isLoading('suggestions') &&
            (this.upgradeAvailable()
                || !!(this.multiGuestUpgrades
                    && this.multiGuestUpgrades.length > 0));
    }

    canShowRelated (type) {
        if (this.loadingService.isLoading('suggestions')) {
            return false;
        }

        this.related = this.related || this.suggestionsService.getRelated();

        return !!(this.related[type] &&
            Object.keys(this.related[type]).length > 0);
    }

    getRelated (type) {
        return this.related[type];
    }

    guestName (guest, suffix) {
        return this.guestname.format(guest, true, suffix);
    }

    hasNoSuggestions () {
        return !this.loadingService.isLoading('suggestions')
            && !this.upgradeAvailable()
            && !this.suggestionsService.hasRelated();
    }

    canUpgradeSingleItem (item) {
        return item.item_summary && item.item_summary.minimum_guests === 1
            && (!!item.canUpgradeTo || item.upgraded === 1);
    }

    setMultiGuestUpgrades () {
        this.multiGuestUpgrades = [];
        this.basket.contents.guest_details.forEach(guest => {
            guest.item_details.forEach(item => {
                if (item.item_summary.minimum_guests > 1
                    && (item.canUpgradeTo || item.upgraded === 1)) {

                    const guestName = this.guestname.format(guest, true);

                    if (this.multiGuestUpgrades.length > 0) {
                        const foundUpgrade = this.multiGuestUpgrades.find(upgrade => upgrade.reference === item.reference);

                        if (foundUpgrade) {
                            foundUpgrade.guests.push(guestName);
                            foundUpgrade.items.push(item);
                            return;
                        }
                    }

                    this.multiGuestUpgrades.push({
                        guests: [guestName],
                        items: [item],
                        reference: item.reference
                    });
                }
            });
        });
    }
}

DisplaySuggestionsController.$inject = ['basket', 'checkout', 'suggestionsService', 'guestnameService', 'loadingService'];

export default DisplaySuggestionsController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/checkout/controllers/display.suggestions.controller.js